import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import RenovarAsignacionDialog from "./RenovarAsignacionDialog";
import NoRenovarAsignacionDialog from "./NoRenovarAsignacionDialog";


const AlertasDialog = ({ visible, htmlContent, onContinue, onCancel, renewProps, motivosOptions, motivosOptions2, onToast }) => {

    const navigate = useNavigate();
    const [showRenovarDialog, setShowRenovarDialog] = useState(false);
    const [showNoRenovarDialog, setShowNoRenovarDialog] = useState(false);
    const extractItemByKeyword = (html, keyword) => {
        const container = document.createElement('div');
        container.innerHTML = html || '';
        const items = Array.from(container.querySelectorAll('li'));
        const found = items.find(li => li.textContent.toLowerCase().includes(keyword.toLowerCase()));
        return found ? found.textContent : null;
    };

    return (
        <Dialog
            header={`Alertas de la Asignación Nro.° ${renewProps?.idCotizacion}`}
            visible={visible}
            className="p-fluid product-dialog"
            modal
            onHide={onCancel}
            footer={
                <>
                    <Button
                        label="Continuar"
                        icon="pi pi-arrow-right"
                        className="p-button-rounded p-button-primary mb-2"
                        onClick={onContinue}
                        raised
                    />
                </>
            }
        >
            <div className="card">
                <p className="text-color-secondary mb-3">
                    A continuación se presentan las alertas de la asignación, las cuales requieren la siguiente atención: 
                </p>
                {(!htmlContent || (!htmlContent.includes("renegociación") && !htmlContent.includes("Contrato") && !htmlContent.includes("deuda") && !htmlContent.includes("renovada"))) ? (
                    <div>Sin alertas</div>
                ) : (
                    <div>
                        {htmlContent.includes("renegociación") && (
                            <div className="card mb-3">
                                <p style={{ marginTop: "10px", fontSize: "16px" }}>• {extractItemByKeyword(htmlContent, "renegociación")}</p>
                                <div className="flex justify-content-end">
                                    <Button
                                        label="No Renovar"
                                        icon="pi pi-times"
                                        className="p-button p-button-danger p-button-rounded mr-2"
                                        onClick={() => setShowNoRenovarDialog(true)}
                                        raised
                                    />
                                    <Button
                                        label="Renovar"
                                        icon="pi pi-forward"
                                        className=" p-button p-button-info p-button-rounded"
                                        onClick={() => setShowRenovarDialog(true)}
                                        raised
                                    />
                                </div>
                            </div>
                        )}

                        {htmlContent.includes("Contrato") && (
                            <div className="card mb-3">
                                <p style={{ marginTop: "10px", fontSize: "16px" }}>• {extractItemByKeyword(htmlContent, "Contrato")}</p>
                                <div className="flex justify-content-center">
                                    <Button
                                        label="Ir a Contrato"
                                        icon="pi pi-file-word"
                                        className="p-button p-button-help p-button-rounded"
                                        onClick={() => navigate("/documentos", { state: { cliente: renewProps.RazonSocial } })}
                                        style={{ width: "400px" }}
                                        raised
                                    />
        
                                </div>   
                            </div>
                        )}

                        {htmlContent.includes("deuda") && (
                            <div className="card mb-3">
                                <p style={{ marginTop: "10px", fontSize: "16px" }}>• {extractItemByKeyword(htmlContent, "deuda")}</p>
                                <Button
                                    label="Revisar Deuda"
                                    icon="pi pi-credit-card"
                                    className="p-button-info p-button-rounded p-button"
                                    onClick={() => window.open("https://cobranzas.kesp.cl", "_blank")}
                                    raised
                                />
                            </div>
                        )}

                        {htmlContent.includes("renovada") && (
                            <div className="card mb-3">
                                <p style={{ marginTop: "10px", fontSize: "16px" }}>• {extractItemByKeyword(htmlContent, "renovada")}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {renewProps && (
                <>
                    <RenovarAsignacionDialog
                        visible={showRenovarDialog}
                        onHide={() => setShowRenovarDialog(false)}
                        idCotizacion={renewProps.idCotizacion}
                        idCliente={renewProps.idCliente}
                        desde={renewProps.desde}
                        hasta={renewProps.hasta}
                        motivosOptions={motivosOptions}
                    />

                    <NoRenovarAsignacionDialog
                        visible={showNoRenovarDialog}
                        onHide={() => setShowNoRenovarDialog(false)}
                        idCotizacion={renewProps.idCotizacion}
                        idCliente={renewProps.idCliente}
                        desde={renewProps.desde}
                        hasta={renewProps.hasta}
                        motivosOptions={motivosOptions2}
                    />
                </>
                
            )}
        </Dialog>
    );
};

export default AlertasDialog;